export default __webpack_public_path__ + "static/media/device_yangek_on.00cc13cd.svg";